export const IMAGE_RATIOS = {
  SQUARE: 1,
  WIDE: 16 / 9,
  PORTRAIT: 3 / 4,
  PRODUCT: 4 / 5,
} as const;

export type ImageRatioType = keyof typeof IMAGE_RATIOS;

export const OPTIMAL_DIMENSIONS: Record<ImageRatioType, number> = {
  SQUARE: 1080,
  WIDE: 1920,
  PORTRAIT: 1440,
  PRODUCT: 1440,
} as const;

export const IMAGE_ASPECT_CLASSES = {
  SQUARE: 'aspect-square',
  WIDE: 'aspect-video',
  PORTRAIT: 'aspect-3/4',
  PRODUCT: 'aspect-[4/5]',
} as const;
